module.exports = __webpack_public_path__ + "img/T30.9b86318c.jpg";